/* eslint-disable */
import Vue from 'vue';
import WebFont from 'webfontloader';
import axios from 'axios';
import * as Sentry from '@sentry/vue';
import UserToken from '../../classes/UserToken';
import utils from '../../utils';

const state = {
  pollId: null,
  oldPollId: null,
  isActive: true,
  question: '',
  description: '',
  options: [],
  feedback: '',
  totalVotes: 0,
  showTimer: false,
  showThankYou: true,
  showAnimatedBackground: false,
  showAdmin: false,
  cornerStyle: 'round',
  fontProvider: 'google',
  generalLimit: 1,
  fontId: 'Open Sans',
  questionTextColor: '#FFFFFF',
  answerBackgroundColor: '#ffffff4d',
  answerTextColor: '#FFFFFF',
  WEBIsHorizontal: false,
  WEBMultiSelect: false,
  stayTunedBackground: null,
  stayTunedTemplate: 'spectrum',
  fontLoaded: false,
  background: null,
  WEBBackgroundURI: 'none',
  WEBHeaderImageURI: 'none',
  WEBCallToActionSelectedBackground: 'none',
  WEBCallToActionText: '',
  WEBCorrectAnswerText: null,
  WEBNextLinkButtonTitle: null,
  WEBNextPollId: null,
  WEBNextType: 'none',
  WEBTemplateName: 'nextGen',
  pollType: null,
  WEBOnPollClosing: 'tuned',
  WEBResultPageText: 'Results',
  WEBShowCorrectOption: false,
  WEBCanSkip: false,
  WEBTimeLimit: -1,
  WEBStoryLinkImage: null,
  WEBStoryLinkText: null,
  WEBStoryLinkURL: null,
  twitterEnabled: false,
  facebookEnabled: false,
  smsEnabled: false,
  WEBVotingEnabled: true,
  WEBResultsEnabled: true,
  submitButtonText: 'Vote',
  thankYouMessage: 'Thank you',
  websocketSetup: false,
  loaded: false,
  componentsLoaded: false,
  votingEnabled: true,
  votingComplete: false,
  type: 'poll',
  presentationBackground: '',
  resetEnabled: false,
  position: 0,
  hasNextPoll: true,
  endedTimers: JSON.parse(localStorage.getItem('endedTimers') || '{}'),
  next: false,

  // FROM EJS
  staticContentLink: window.staticContentLink,
  assetsLink: window.assetsLink,
  accountName: window.accountName,
  activeLinkParams: window.activeLinkParams,
  wsOrigin: window.wsOrigin,
  wsPath: window.wsPath,
  environment: window.environment,
  basePath: window.basePath,
  viewType: window.viewType,
  lastWebPollId: window.lastWebPollId,
  revision: window.revision || 0,
  audienceQaEnabled: window.audienceQaEnabled,
  audienceQaLink: window.audienceQaLink,
  templateLinks: window.templateLinks,
  dynamicLink: window.dynamicLink,
  pollSettingsLink: window.pollSettingsLink,
  previewData: window.previewData,
  permissions: window.permissions,
  captchaEnabled: window.captchaEnabled,
  isFreeAccount: false,
  group: '',
  trustedDomains: [],
  wordCloudData: [],
  qaData: [],
  colorCache: {},
  qaListURL: '',
  wordCloudListURL: '',
  features: {},
  showOptionModal: false,
  optionActionText: '',
  voteLimitReached: false,
  pollGroupId: null,
  voteExists: false
};

const initialStateCopy = JSON.parse(JSON.stringify(state));

export default {
  namespaced: true,
  state,
  getters: {
    pollWebsocketRequests(state) {
      const connectionRequests = [{
        action: 'join',
        groupName: `/poll:${state.pollId}`
      }];
      state.oldPollId && connectionRequests.push({
        action: 'leave',
        groupName: `/poll:${state.oldPollId}`
      });
      return connectionRequests;
    },
    isPollGroupMode(state) {
      return !!state.accountName;
    },
    showMultiVote(state) {
      return state.WEBMultiSelect;
    },
    getOptionById: (state) => (id) => {
      return state.options.find((option) => option.id === id);
    },
    backgroundURL(state) {
      return (state.WEBBackgroundURI || '') === 'none' ? '' : `${(state.WEBBackgroundURI || '').includes('http') ? '' : state.templateLinks.staticContent}${state.WEBBackgroundURI}`;
    },
    selectedOptions(state) {
      return state.options.filter(({selected}) => selected);
    },
    selectedMaxOptions(state) {
      const selectedOptions = state.options.filter(({selected}) => selected);
      return state.generalLimit === selectedOptions.length;
    },
    fontFamilyCSS(state) {
      return `${state.fontId}`;
    },
    pollId(state) {
      return state.pollId;
    },
    playLink(state) {
      return `${state.templateLinks.playBase}${state.accountName ? `${state.accountName}/` : ''}`;
    },
    oldPollId(state) {
      return state.oldPollId;
    },
    templateName(state) {
      return state.WEBTemplateName;
    },
    pollType(state) {
      return state.pollType;
    },
    viewType(state) {
      return state.viewType;
    },
    headerEnabled(state) {
      return (state.activeLinkParams || '').includes('h=1');
    },
    getPollResultsByIdLink(state) {
      const domainNameSuffix = {
        prod: '',
        staging: 'qa',
        preprod: 'pre',
        local: 'l'
      };
      return `https://vote${domainNameSuffix[state.environment]}.digitaljoy.media/api/poll/${state.pollId}/results`;
    },
    unauthorizedLink(state) {
      const template = (state.stayTunedTemplate === 'custom')
        ? state.stayTunedTemplate + '?background=' + state.stayTunedBackground
        : state.stayTunedTemplate || 'spectrum';
      const group = (state.stayTunedTemplate === 'custom') ? `&group=${state.group}` : `?group=${state.group}`;
      return `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_ENVIRONMENT !== 'local' ? '/s' : ''}/play/unauthorized-template/${template}${group}`;
    },
    stayTunedLink(state) {
      const template = (state.stayTunedTemplate === 'custom')
        ? state.stayTunedTemplate + '?background=' + state.stayTunedBackground
        : state.stayTunedTemplate || 'spectrum';
      const group = (state.stayTunedTemplate === 'custom') ? `&group=${state.group}` : `?group=${state.group}`;
      return `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_ENVIRONMENT !== 'local' ? '/s' : ''}/play/stay-tuned-template/${template}${group}`;
    },
    isDynamicLink(state) {
      return state.viewType === 'dynamic';
    },
    isVoteable(state) {
      return state.WEBVotingEnabled && (state.viewType === 'dynamic' ? state.isActive : true);
    },
    getFeedback(state) {
      return state.feedback;
    },
    wordCloudData(state) {
      return state.wordCloudData;
    },
    qaData(state) {
      return state.qaData;
    },
    nextLink(state, { playLink }) {
      let nextLink = '';
      let targetPollId = 0;
      const nextType = state.WEBNextType || '';
      if (nextType === 'poll') {
        targetPollId = state.WEBNextPollId;
        nextLink = (targetPollId) ? `${playLink}${targetPollId}?${state.activeLinkParams}` : '';
      } else if (nextType === 'leaderboard') {
        nextLink = `${playLink}leaderboard?${state.activeLinkParams}`;
      } else if (nextType === 'callToAction') {
        targetPollId = state.pollId;
        nextLink = (targetPollId) ? `${playLink}${targetPollId}/message?${state.activeLinkParams}` : '';
      }
      return nextLink;
    },
    accountName(state) {
      return state.accountName;
    },
    formattedWEBStoryLinkImage(state) {
      return (state.WEBStoryLinkImage && state.WEBStoryLinkImage.lastIndexOf('http', 0) === -1) ?
        'http://' + state.WEBStoryLinkImage :
        state.WEBStoryLinkImage;
    },
    formattedWEBStoryLinkURL(state) {
      return (state.WEBStoryLinkURL && state.WEBStoryLinkURL.lastIndexOf('http', 0) === -1) ?
        'http://' + state.WEBStoryLinkURL :
        state.WEBStoryLinkURL;
    },
    submitButtonText(state) {
      return state.submitButtonText;
    },
    thankYouMessage(state) {
      return state.thankYouMessage;
    },
    isFeedbackPoll(state) {
      return ['wordCloud', 'qa'].includes(state.pollType);
    },
    captchaEnabled(state) {
      return state.captchaEnabled;
    },
    options(state) {
      return state.options;
    },
    presentationBackground(state) {
      return state.presentationBackground;
    },
    isTimerEnded(state) {
      return !!state.endedTimers[state.pollId];
    }
  },
  mutations: {
    toggleSetting(state, key, override) {
      state[key] = typeof override === 'boolean' ? override : !state[key];
    },
    disableVoting(state) {
      state.votingEnabled = false;
    },
    showNext(state) {
      state.next = true;
    },
    disableNext(state) {
      state.next = false
    },
    setAccountName(state, accountName) {
      state.accountName = accountName;
    },
    setPollGroupId(state, pollGroupId) {
      state.pollGroupId = pollGroupId;
    },
    setEJSVariables(state, {
      templateName,
      staticContentLink,
      assetsLink,
      accountName,
      activeLinkParams,
      wsOrigin,
      wsPath,
      environment,
      basePath,
      viewType,
      lastWebPollId,
      audienceQaEnabled,
      audienceQaLink,
      templateLinks,
      dynamicLink,
      pollSettingsLink,
      previewData,
      permissions,
      captchaEnabled,
      gamificationLinks,
      revision
    }) {
      state.templateName = templateName;
      state.staticContentLink = staticContentLink;
      state.assetsLink = assetsLink;
      state.accountName = accountName;
      state.activeLinkParams = activeLinkParams;
      state.wsOrigin = wsOrigin;
      state.wsPath = wsPath;
      state.environment = environment;
      state.basePath = basePath;
      state.viewType = viewType;
      state.lastWebPollId = lastWebPollId;
      state.revision = revision;
      state.audienceQaEnabled = audienceQaEnabled;
      state.audienceQaLink = audienceQaLink;
      state.templateLinks = templateLinks;
      state.dynamicLink = dynamicLink;
      state.pollSettingsLink = pollSettingsLink;
      state.previewData = previewData;
      state.permissions = permissions;
      state.captchaEnabled = captchaEnabled;
      state.gamificationLinks = gamificationLinks;

      const userToken = new UserToken();
      if (revision !== userToken.getRevision(lastWebPollId)) {
        userToken.clearTokens(lastWebPollId);
      }
    },
    setWebsocketSetup(state) {
      state.websocketSetup = true;
    },
    enableVoting(state) {
      state.votingEnabled = true;
    },
    setResetEnabled(state, value) {
      state.resetEnabled = value;
    },
    completeVoting(state) {
      state.votingComplete = true;
    },
    toggleSelection(state, optionId) {
      const selectedOption = state.options.find(({id}) => id === optionId);
      selectedOption.selected = !selectedOption.selected;
    },
    setCornerStyle(state, cornerStyle) {
      ['round', 'square'].includes(cornerStyle) ?
        state.cornerStyle = cornerStyle :
        state.cornerStyle = 'round';
    },
    setPollId(state, pollId) {
      state.oldPollId = state.pollId;
      state.pollId = pollId;
    },
    setQuestion(state, question) {
      state.question = question;
    },
    setDescription(state, description) {
      state.description = description;
    },
    setPresentationBackground(state, background) {
      state.presentationBackground = background;
    },
    setIsFreeAccount(state, value) {
      state.isFreeAccount = value;
    },
    setVoteExists(state, value) {
      state.voteExists = value;
    },
    setOptions(state, {options, WEBCorrectOptionId, WEBShowCorrectOption, playLink}) {
      state.options = options.map(
        ({
           id,
           optionText: text,
           percentage: percent,
           image,
           optionImage,
           nextLink,
           nextLinkType
         }) => ({
          id,
          text,
          percent,
          image: image || optionImage,
          formattedImage: (image || optionImage) ? `${state.assetsLink}${image || optionImage}` : null,
          nextLinkType,
          nextLink: nextLink && nextLinkType ? `${nextLinkType === 'poll' ? playLink : ''}${nextLink}${nextLinkType === 'poll' ? `?${state.activeLinkParams}` : ''}` : '',
          selected: false,
          correct: WEBCorrectOptionId === id && WEBShowCorrectOption
        }));
    },
    setActive(state, active) {
      state.isActive = active;
    },
    setPollType(state, type) {
      state.pollType = type;
    },
    setPosition(state, position) {
      state.position = position;
    },
    setNextPoll(state, hasNext) {
      state.hasNextPoll = hasNext;
    },
    setSubmitButtonText(state, value) {
      state.submitButtonText = value;
    },
    setWebVotingEnabled(state, settings) {
      try {
        const {
          poll_setting: {
            WEBVotingEnabled
          }
        } = settings;
        state.WEBVotingEnabled = WEBVotingEnabled;
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    setBackground(state, background) {
      state.background = background;
    },
    setTrustedDomains(state, domains) {
      state.trustedDomains = domains;
    },
    setWordCloudListURL(state, accountName) {
      state.wordCloudListURL = `${state.templateLinks.userBase}/${accountName}/poll/${state.pollId}/wordcloud`;
    },
    setQaListURL(state, accountName) {
      state.qaListURL = `${state.templateLinks.userBase}/${accountName}/poll/${state.pollId}/qa`;
    },
    setFeatures(state, features) {
      state.features = features;
    },
    setWordCloudData(state, { data, init }) {
      if (init) {
        state.wordCloudData = data;
        return;
      }
      state.wordCloudData = Object.values([
        ...state.wordCloudData,
        ...data.filter(({ state }) => state !== 'profane')
        ]
        .reduce((r, e) => {
          const key = e.message || e.tag;
          if (!r[key]) {
            r[key] = { tag: e.message || e.tag, weight: e.weight || 1 };
          } else {
            r[key].weight += 1;
          }
          return r;
        }, {}));
    },
    setQaData(state, { data, init }) {
      const randomColor = (id) => {
        const r = () => Math.floor(256 * Math.random());
        return state.colorCache[id] || (state.colorCache[id] = `rgb(${r()}, ${r()}, ${r()})`);
      };
      state.qaData = [
        ...data
          .filter(({ state }) => state !== 'profane')
          .map((question) => ({
            ...question,
            color: randomColor(question.author)
          })),
        ...(!init ? state.qaData : [])
      ];
    },
    removeFeedback(state, data) {
      if (state.pollType === 'qa') {
        const index = state.qaData.findIndex(({ feedbackId }) => feedbackId === data.feedbackId);
        index !== -1 && state.qaData.splice(index, 1);
      } else if (state.pollType === 'wordCloud') {
        state.wordCloudData.map((feedback) => {
          if (feedback.tag === (data.feedback || {}).message && feedback.weight) {
            if (feedback.weight > 1) {
              --feedback.weight;
            } else {
              const index = state.wordCloudData.findIndex(({ tag }) => tag === (data.feedback || {}).message);
              index !== -1 && state.wordCloudData.splice(index, 1);
            }
          }
          return feedback;
        });
      }
    },
    loadFont(state, font) {
      switch (state.group) {
        case 'bbl':
          font.provider = 'custom';
          font.url = 'static/nextgen/webfonts/FordAntenna.css';
          font.id = 'Ford Antenna';
          break;
        case 'cryms':
          font.id = 'Oswald';
          break;
      }
      const data = {
        fontloading() {
          state.fontLoaded = false;
        },
        fontactive() {
          state.fontId = font.id;
          state.fontProvider = font.provider;
          state.fontLoaded = true;
        }
      };
      switch (font.provider) {
        case 'google':
          data[font.provider] = {
            families: [`${font.id}:300,400,500,600,700`]
          };
          break;
        case 'custom':
          data[font.provider] = {
            urls: [font.url]
          }
          state.fontId = font.id;
          state.fontProvider = font.provider;
          state.fontLoaded = true;
          break;
      }
      WebFont.load(data);
    },
    setLoaded(state, { isFeedbackType }) {
      state.loaded = true;
      state.next = false;
      state.votingEnabled = !isFeedbackType;
      state.votingComplete = false;
      state.resetEnabled = false;
      state.feedback = '';
    },
    setComponentsLoaded(state, value) {
      state.componentsLoaded = value;
    },
    updateOptionsResult(state, data) {
      state.options = state.options.map((option) => {
        if (typeof data[option.id] === 'number') {
          option.percent = data[option.id] || 0;
        }
        return option;
      });
    },
    updateOptionsResultFromVotes(state, votes) {
      for (const optionId in votes) {
        if (!state.options.some(opt => opt.id === +optionId)) {
          delete votes[optionId];
        }
      }

      const oldTotal = state.totalVotes;
      const newVotes = Object.values(votes).reduce((res, curr) => res + curr, 0);
      const newTotal = oldTotal + newVotes;

      for (const opt of state.options) {
        const optionId = Object.keys(votes).find(id => opt.id === +id);

        const votesBefore = Math.round((opt.percent / 100) * oldTotal);

        if (optionId) {
          const votesAfter = votesBefore + votes[optionId];
          opt.percent = (votesAfter / newTotal) * 100;
        } else {
          opt.percent = (votesBefore / newTotal) * 100;
        }
      }
      state.totalVotes = newTotal;
    },
    computeDisplayPercentages(state) {
      let runningTotal = 0;
      let previousValue = 0;
      state.options = state.options.map((option) => {
        runningTotal += option.percent;
        option.displayPercent = Math.round(runningTotal);
        return option;
      });
      state.options = state.options.map((option) => {
        runningTotal = option.displayPercent;
        option.displayPercent -= previousValue;
        previousValue = runningTotal;
        return option;
      });
    },
    updateTotalVotes(state, total) {
      state.totalVotes = total;
    },
    updatePollSettings(state, data) {
      Object.assign(state, data);
    },
    setFeedback(state, value) {
      state.feedback = value;
    },
    setThankYouMessage(state, value) {
      state.thankYouMessage = value;
    },
    setGroup(state, name) {
      state.group = name;
    },
    setOptionActionText(state, text) {
      state.showOptionModal = !!text;
      state.optionActionText = text;
    },
    setVizualizationType(state, vizualizationType) {
      state.vizualizationType = vizualizationType;
    },
    endTimer(state) {
      Vue.set(state.endedTimers, state.pollId, true);
      localStorage.setItem('endedTimers', JSON.stringify(state.endedTimers));
    },
  },
  actions: {
    reset({ state }) {

    },
    getAccountParameters({ commit, dispatch }) {
      const path = window.location.pathname.replace('/play', '/');
      const templatePathBase = '/';
      const [, identifier, , pollGroupId] = path.replace(templatePathBase, '').split('/');

      // info: identifier is the accountName or pollId
      if (identifier) {
        isNaN(+identifier) ? commit('setAccountName', identifier) : commit('setPollId', identifier);
      }
    },
    async checkActivePollWhitelist({ state, commit }) {
      try {
        const { data: user } = await axios.get(`${process.env.VUE_APP_SLS_URL}/api/poll/active/${state.accountName}`);
        return user && user.whitelistId;
      } catch (e) {
        throw new Error(e);
      }
    },
    savePollSettings({getters, commit, rootGetters, dispatch}, data) {
      try {
        if (!(data || {}).type) return;
        const {
          id: pollId,
          type,
          isActive,
          poll_questions: [{
            question,
            description,
            poll_options: options
          }],
          poll_setting: settings,
          position
        } = data;
        console.log('savePollSettings', pollId)
        commit('setPollId', pollId);
        commit('setActive', isActive || rootGetters['pollGroup/pollGroupModeActive']);
        commit('setQuestion', question);
        commit('setDescription', description);
        commit('setPollType', type);
        commit('setPosition', position);
        if (getters.isFeedbackPoll) {
          commit('setSubmitButtonText', 'Submit');
        }
        commit('setOptions', {
          options,
          WEBCorrectOptionId: settings.WEBCorrectOptionId,
          WEBShowCorrectOption: settings.WEBShowCorrectOption,
          playLink: getters.playLink
        });
        commit('updatePollSettings', settings);
        commit('loadFont', {
          id: settings.fontId,
          provider: 'google'
        });
        commit('setLoaded', {isFeedbackType: getters.isFeedbackPoll});
        if (state.WEBTimeLimit !== -1) {
          dispatch('voter/setTimeLimit', state.WEBTimeLimit, { root: true });
        }
        let authenticationMethods = {};
        if (settings.authenticationMethods) {
          authenticationMethods = settings.authenticationMethods;
        } else {
          authenticationMethods = {
            "passwordFree": settings.authenticationPasswordFree,
            "google": settings.authenticationGoogle,
            "microsoft": settings.authenticationMicrosoft,
            "email": settings.authenticationEmail,
            "facebook": settings.authenticationFacebook
          };
        }
        console.log('authenticationMethods', authenticationMethods);
        commit('voter/setAuthenticationMethods', authenticationMethods, { root: true });
      } catch (e) {
        console.log('e', e);
        Sentry.captureException(e);
      }
    },
    async loadTemplateVariables({ state, commit, dispatch }) {
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_ENVIRONMENT !== 'local' ? '/s' : ''}/play/${state.accountName || state.pollId}/data${window.location.search}`);
      const params = new URLSearchParams(window.location.search);
      const templateInfo = JSON.parse(params.get('templateInfo'));
      data.previewData = (templateInfo || {}).pollInfo;
      data.isPreview = (state.accountName || state.pollId) === 'preview';
      commit('setEJSVariables', data);
      dispatch('voter/setEJSVariables', data, { root: true });

      if (data.isPreview) {
        await dispatch('loadPollSettings');
      }
    },
    async toggleActive({ state }) {
      if (!state.permissions.canStartStopPolls) return;
      utils.embedCode() ?
      await axios.post(`${state.isActive ? state.templateLinks.stopPoll : state.templateLinks.startPoll}?id=${state.pollId}&eId=${utils.embedCode()}`, {}) :
      await axios.post(`${state.isActive ? state.templateLinks.stopPoll : state.templateLinks.startPoll}?id=${state.pollId}`, {}, {
        headers: {
          Authorization: `Bearer ${utils.token()}`
        }
      });
    },
    async getNextPollId({ state }) {
      const {
        data: {
          nextPollId
        }
      } = utils.embedCode() ?
        await axios.get(`${state.templateLinks.nextPoll}?id=${state.pollId}&eId=${utils.embedCode()}`) :
        await axios.get(`${state.templateLinks.nextPoll}?id=${state.pollId}`, {
          headers: {
            Authorization: `Bearer ${utils.token()}`
          }
        });
      return nextPollId;
    },
    async getPreviousPollId({ state }) {
      const {
        data: {
          prevPollId
        }
      } = utils.embedCode() ?
        await axios.get(`${state.templateLinks.previousPoll}?id=${state.pollId}&eId=${utils.embedCode()}`) :
        await axios.get(`${state.templateLinks.previousPoll}?id=${state.pollId}`, {
          headers: {
            Authorization: `Bearer ${utils.token()}`
          }
        });
      return prevPollId;
    },
    async loadPollSettings({ state, commit, dispatch, rootGetters, rootState }) {
      try {
        if ((state.previewData || {}).poll_setting) {
          dispatch('savePollSettings', {
            type: state.previewData.type,
            poll_setting: {
              WEBTemplateName: 'nextGen',
              WEBBackgroundURI: state.previewData.poll_setting.WEBBackgroundURI,
              WEBHeaderImageURI: state.previewData.poll_setting.selectedHeaderImage,
              fontId: state.previewData.poll_setting.fontId,
              WEBIsHorizontal: state.previewData.poll_setting.WEBIsHorizontal,
              WEBMultiSelect: state.previewData.poll_setting.WEBMultiSelect,
              questionTextColor: state.previewData.poll_setting.questionTextColor,
              answerBackgroundColor: state.previewData.poll_setting.answerBackgroundColor,
              answerTextColor: state.previewData.poll_setting.answerTextColor,
              cornerStyle: state.previewData.poll_setting.cornerStyle
            },
            poll_questions: [{
              question: state.previewData.poll_questions[0].question,
              description: state.previewData.poll_questions[0].description,
              poll_options: state.previewData.poll_questions[0].poll_options
            }]
          });
          dispatch('pollGroup/setBrandingName', state.previewData.brandingName, { root: true });
          dispatch('pollGroup/setBrandingImage', state.previewData.brandingImage, { root: true });
          dispatch('pollGroup/setLeaderboardEnabled', state.previewData.leaderboardEnabled, { root: true });
          dispatch('pollGroup/scoring', state.previewData.scoring, { root: true });
          commit('setIsFreeAccount', true);
          
          //Is on preview, don´t show opt-in
          return [false, ''];
        } else {
          let pollSettingsUrl = `${state.pollSettingsLink}`
          pollSettingsUrl = pollSettingsUrl.includes('?') ? `${pollSettingsUrl}&id=${state.pollId}` : `${pollSettingsUrl}?id=${state.pollId}`;

          let response;
          if (rootGetters['pollGroup/pollGroupModeActive']) {
            response = await axios.get(`${process.env.VUE_APP_SLS_URL}/api/poll/${state.pollId}/settings`, {
              params: {
                timestamp: new Date().getTime(),
                ...((rootState.voter || {}).voterId ? { voterId: rootState.voter.voterId } : {})
              }
            }).catch((err) => {
              console.log('err', err);
            });
          } else if (utils.embedCode()) {
            response = await axios.get(`${pollSettingsUrl}&eId=${utils.embedCode()}`, {
              params: {
                timestamp: new Date().getTime(),
                ...((rootState.voter || {}).voterId ? { voterId: rootState.voter.voterId } : {})
              }
            }).catch((err) => {
              console.log('err', err);
            });
          } else {
            const headers = {};
            const token = state.viewType === 'presentation' ? utils.token() : null;
            headers.Authorization = `Bearer ${token || 'null'}`;
            response = await axios.get(pollSettingsUrl, {
              params: {
                timestamp: new Date().getTime(),
                ...((rootState.voter || {}).voterId ? { voterId: rootState.voter.voterId } : {})
              },
              headers
            }).catch((err) => {
              console.log('err', err);
            });
          }

          const {
            pollInfo,
            isFreeAccount,
            voteId,
            voteExists,
          } = response.data || { pollInfo: {} };

          if (!rootGetters['pollGroup/pollGroupModeActive'] &&
            (!pollInfo || (!pollInfo.isActive && state.viewType === 'dynamic' && +pollInfo.id !== +state.lastWebPollId))
          ) {
            console.log('setActive', false);
            commit('setActive', false);
            return [false, ''];
          }
          // @todo find a better way for all the group styles
          if (state.group === 'veev') {
            pollInfo.poll_setting.answerBackgroundColor = '#a28452';
          } else if (state.group === 'bbl') {
            pollInfo.poll_setting.answerBackgroundColor = '#ffffff4d';
          }

          dispatch('savePollSettings', pollInfo);
          commit('setIsFreeAccount', isFreeAccount);
          dispatch('voter/setVoteId', voteId, { root: true });
          if (voteExists) {
            commit('setVoteExists', voteExists);
          }
          return [pollInfo.poll_setting.isOptInEnabled, pollInfo.poll_setting.optInText];
        }
      } catch (e) {
        console.error(e);
        if ((e.response || {}).status === 404) {
          commit('setPollId', null);
          commit('setNextPoll', false);
        }
        Sentry.captureException(e);
      }
    },
    async loadPollResults({commit, getters, state}) {
      try {
        if (!state.pollId) return;
        const {
          data
        } = await axios.get(getters.getPollResultsByIdLink);
        if (!data) return;
        const {
          percentages,
          total
        } = data;
        commit('updateOptionsResult', percentages);
        commit('updateTotalVotes', total);
        commit('computeDisplayPercentages');
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    async loadTrustedDomains({ commit, state }) {
      try {
        const {
          data
        } = await axios.get(state.templateLinks.trustedDomainsURL);
        if (!data) return;
        commit('setTrustedDomains' +
          '' +
          '', data.map((d) => d.url));
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    async loadWordCloudResults({ state, commit, getter }, accountName) {
      try {
        accountName && commit('setWordCloudListURL', accountName);
        const {
          data: body
        } = await axios.get(state.wordCloudListURL, {
          params: {
            state: 'all',
            refDateTime: 0,
            checkModeration: true
          }
        });
        commit('setWordCloudData', { data: body, init: true });
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    async loadQaResults({ state, commit, getter }, accountName) {
      try {
        accountName && commit('setQaListURL', accountName);
        const {
          data: body
        } = await axios.get(state.qaListURL, {
          params: {
            state: 'all',
            refDateTime: 0,
            checkModeration: true
          }
        });
        commit('setQaData', {
          data: body,
          init: true
        });
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    async loadPollFeatures({state, commit}) {
      try {
        const {
          data: {
            body
          }
        } = await axios.get(`${state.templateLinks.pollBase}${state.pollId}/features`);
        commit('setFeatures', JSON.parse(body));
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    toggleSetting({commit}, key, override = null) {
      commit('toggleSetting', key, override);
    },
    timeExpired({commit}) {
      commit('disableVoting');
    },
    async checkVoteLimit({dispatch, getters, state, commit}) {
      const voterId = new UserToken().getByPollIdIfExists(state.pollId);

      if (voterId) {
        const { data: { canVote } } = await axios.post(`${process.env.VUE_APP_SLS_URL}/api/vote-allowed`, {
          accountName: state.accountName,
          pollId: state.pollId,
          voterId
        });
        state.voteLimitReached = !canVote;
      }

      console.log('state.generalLimit', state.generalLimit, voterId);
    },
    async vote({dispatch, getters, state, commit}, {recaptchaToken, registerVote}) {
      console.log('vote!')
      dispatch('completeVoting');
      const options = getters.selectedOptions;
      !getters.showMultiVote && options.length === 1 && commit('toggleSelection', options[0].id);

      try {
        for (const {id: optionId} of options) {
          const data = {
            id: optionId,
            pollId: state.pollId,
            accountName: state.accountName,
            count: 1,
            userCookie: new UserToken().getByPollId(state.pollId, state.revision),
            recaptchaToken
          };
          // @todo: Future, combine these two hits
          await axios.post(state.templateLinks.submitVote, data, {
            headers: {
              'Content-Type': 'application/json',
            }
          });
          await registerVote(data);
        }
      } catch (e) {
        console.log('e', e);
        Sentry.captureException(e);
      }
    },
    async submitFeedback({dispatch, state}, recaptchaToken) {
      // dispatch('completeVoting');

      await axios.post(state.templateLinks.submitFeedback, {
        pollId: state.pollId,
        message: state.feedback,
        voterId: new UserToken().getByPollId(state.pollId, state.revision),
        recaptchaToken
      });
      dispatch('completeVoting');
    },
    completeVoting({commit, state}) {
      state.generalLimit === 1
        ? commit('disableVoting')
        : commit('setResetEnabled', true);
      commit('completeVoting');
    },
    setCornerStyle({commit}, cornerStyle) {
      commit('setCornerStyle', cornerStyle);
    },
    loadFont({commit}, font) {
      commit('loadFont', font);
    },
    setBackground({commit}, background) {
      commit('setBackground', background);
    },
    setFeedback({ commit, state, dispatch, getters }, data) {
      if (!getters.isFeedbackPoll) return;
      const feedback = ((data || {}).payload || {}).set || [];
      feedback.forEach((item) => {
        switch(item.action) {
          case 'featureChange':
          case 'reset':
            dispatch('loadPollFeatures');
            if (state.pollType === 'qa') {
              dispatch('loadQaResults');
            } else if (state.pollType === 'wordCloud') {
              dispatch('loadWordCloudResults');
            }
            break;
          case 'move':
            if (item.newState === 'removed' || item.newState === 'archived') {
              commit('removeFeedback', item);
            } else if (item.newState === 'starred' &&
              (item.oldState  === 'archived' || (item.oldState  === 'unread' && state.features.feedbackModerationEnabled))) {
              if (state.pollType === 'qa') {
                commit('setQaData', { data: [item.feedback], init: false });
              } else if (state.pollType === 'wordCloud') {
                commit('setWordCloudData', { data: [item.feedback], init: false });
              }
            }
            break;
          default:
            if (state.features.feedbackModerationEnabled) return;
            if (state.pollType === 'qa') {
              commit('setQaData', { data: feedback, init: false });
            } else if (state.pollType === 'wordCloud') {
              commit('setWordCloudData', { data: feedback, init: false });
            }
        }
      });
    },
    setResults({commit}, data) {
      try {
        const {
          payload: {
            delta,
            set
          }
        } = data;
        if (delta) {
          commit('updateOptionsResultFromVotes', set);
          commit('computeDisplayPercentages');
        } else {
          const results = {};
          const {
            percentages,
            total
          } = set;
          for (let optionId in percentages) {
            results[+optionId.replace('id', '')] = percentages[optionId];
          }
          commit('updateOptionsResult', results);
          commit('updateTotalVotes', total);
          commit('computeDisplayPercentages');
        }
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    updatePollSettings({dispatch, commit}, data) {
      console.log('updatePollSettings', data);
      try {
        const {
          payload: {
            delta,
            set
          }
        } = data;

        if (delta) {
          commit('setWebVotingEnabled', set);
        } else {
          if (state.viewType === 'presentation') {
            commit('setActive', set.id === state.pollId);
          } else {
            dispatch('savePollSettings', set);
            dispatch('loadPollResults');
          }
        }
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    setNewActivePoll({ state, dispatch, commit }, data) {
      console.log('setNewActivePoll', data);
      if (
        (data.payload || {}).removedPollId
        && (data.payload || {}).removedPollId !== state.pollId
      ) return;

      if (state.pollId === (data.payload || {}).removedPollId) {
        commit('setPollId', null);
        commit('setNextPoll', false);
      }
      if (!data.payload || !data.payload.id) {
        commit('setActive', false);
      } else {
        if (state.viewType === 'presentation') {
          commit('setActive', data.payload.id === state.pollId);
        } else {
          dispatch('savePollSettings', data.payload);
          dispatch('loadPollResults');
        }
      }
    },
    resetVoting({commit, getters}) {
      commit('setLoaded', {isFeedbackType: getters.isFeedbackPoll});
    },
    getGroup({ commit }) {
      const params = new URLSearchParams(window.location.search);
      const group = params.get('group') || '';
      commit('setGroup', group);
    },
    resetStateData({ state }) {
      state = Object.assign(state, JSON.parse(JSON.stringify(initialStateCopy)));
    },
    async checkNextPoll({ commit, dispatch }) {
      try {
        const pollId = await dispatch('getNextPollId');
        pollId ? commit('setNextPoll', true) : commit('setNextPoll', false);
      } catch (e) {
        commit('setNextPoll', false);
      }
    },
    async initPoll({ state, commit, dispatch }, pollId) {
      try {
        pollId && commit('setPollId', pollId);
        dispatch('getGroup');
        dispatch('loadFont', {
          id: state.fontId,
          provider: state.fontProvider
        });
        await dispatch('loadPollSettings');
        dispatch('voter/loadHashSettings', {}, { root: true });
        await dispatch('loadPollResults');
        state.viewType === 'nextPoll' && dispatch('voter/setStartTime', Date.now(), { root: true });
      } catch (e) {
        Vue.prototype.$notify({
          group: 'general',
          title: 'Setup failed',
          type: 'error',
          text: e.message.replace(`${e.name}:`, ''),
          duration: 5000
        });
      }
    },
    setComponentsLoaded({ state, commit, dispatch }, loaded) {
      commit('setComponentsLoaded', loaded);
      if (state.showTimer) {
        dispatch('voter/setStartTimeStamp', {}, { root: true });
      }
    }
  }
};
